import { Chip, freddyTheme } from '@coolblue-development/freddy';
import { PinOutlined } from '@coolblue-development/icons';

type Props = {
  locationValue: string;
};

export const LocationChip = ({ locationValue }: Props) => {
  return (
    <Chip startIcon={<PinOutlined fill={freddyTheme.color.icon.subtle} />}>{locationValue}</Chip>
  );
};
